import { nodesCtx } from './schema';
export const nodeFactory = (node) => () => (ctx) => {
    const atom = typeof node === 'function' ? node(ctx) : node;
    ctx.update(nodesCtx, (prev) => prev.concat(atom));
};
//# sourceMappingURL=node-factory.js.map